import React from 'react';
import Header from '../components/Header/Header';
import TeamLayout from '../components/TeamLayout/TeamLayout';
import SeperateHero from '../components/SpecialJoin/SeperateHero';
import BreadcrumbSchema from "./BreadcrumbSchema";

function Gallery() {
  return (
    <div
      style={{
        background: "linear-gradient(to bottom right, rgb(59 130 246 / 0.1), rgb(168 85 247 / 0.1));",
      }}
    >
      <BreadcrumbSchema />
      <Header />

      {/* Add margin-top for spacing below header */}
      <div className="mt-16">
        <TeamLayout />
      </div>

      <SeperateHero />
    </div>
  );
}

export default Gallery;
